import PropTypes from 'prop-types'
import { cn } from 'lib/utils'

export const AdasLink = ({
  children,
  href,
  onClick,
  underline = 'always',
  className,
  // eslint-disable-next-line no-unused-vars
  sx,
  variant,
  component,
  ...props
}) => {
  const underlineClass = underline === 'none' ? 'no-underline' : underline === 'hover' ? 'hover:underline' : 'underline'
  return (
    <a href={href} onClick={onClick} className={cn('text-custom-link cursor-pointer', underlineClass, className)} {...props}>
      {children}
    </a>
  )
}

AdasLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  onClick: PropTypes.func,
  underline: PropTypes.oneOf(['none', 'hover', 'always']),
  className: PropTypes.string
}
